import Image from 'next/image';

const Header = () => {
  return (
    <div className="flex gap-2 pb-6 align-middle">
      <h2 className="sr-only">Tabist Magazine</h2>
      <Image src="/logo.svg" alt="tabist Magazine logo" width={105} height={28} />
      <span className="text-[2em] font-bold">Magazine</span>
    </div>
  );
};

export default Header;
